var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("امتیازات و نظرات")]),_c('p',[_vm._v("امتیازات و نظرات مشتریان را راجع به محصولات مشاهده کنید")]),_vm._l((_vm.comments),function(c,i){return _c('a-comment',{key:i,attrs:{"theShop":_vm.theShop,"theComment":c}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }